import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import { CommentGlowIcon } from "../Iconography";

import "./index.scss";

const CommentToggle = ({
    count,
    active = false,
    disabled = false,
    onToggle,
    className = "",
}) => {
    const handleClick = () => {
        if (disabled || !onToggle) {
            return;
        }
        onToggle();
    };

    return (
        <button
            type="button"
            className={classNames("comment-toggle", className, {
                "comment-toggle--active": active,
            })}
            onClick={handleClick}
            aria-expanded={active}
            disabled={disabled}
        >
            <CommentGlowIcon className="comment-toggle__icon" />
            <span className="comment-toggle__count">{count}</span>
        </button>
    );
};

CommentToggle.propTypes = {
    count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    active: PropTypes.bool,
    disabled: PropTypes.bool,
    onToggle: PropTypes.func,
    className: PropTypes.string,
};

CommentToggle.defaultProps = {
    count: 0,
    active: false,
    disabled: false,
    onToggle: null,
    className: "",
};

export default CommentToggle;
